module.exports = __webpack_public_path__ + "img/blue-banner-ph-1.83c01f22.png";